import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { customLookupTables as saveCustomTable } from 'utils/urls';

import { CustomTable } from 'types/customTables';
import { ErrorModal } from 'types/modalTypes';

export async function postTableInfo(params: TVariables): Promise<TResult> {
  const { AccountId, Id } = params;
  const response = await fetch(saveCustomTable(AccountId), {
    method: Id === 0 ? 'POST' : 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<CustomTable>;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  AccountId: number;
  Columns: Array<string>;
  Id: number;
  TableName: string;
};

type TSnapshot = unknown;

function useSaveCustomTable(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const newTableInfo = await postTableInfo(params);
    if (newTableInfo.Errors) throw newTableInfo;
    else if (newTableInfo.Data) {
      queryClient.invalidateQueries(['get_custom_table']);
      queryClient.invalidateQueries(['custom_records'], {
        refetchInactive: true,
      });
    }
    return newTableInfo;
  });
}

export { useSaveCustomTable };
